import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Form, Loader } from 'vio-components';
import { usePrevious, useReduxState } from 'vio-libs';

import { IMapFeatureRow, IMapFeaturesState } from '../interfaces';
import { requestRemoveLayer, requestRemoveSource } from '../redux';
import { useAppDispatch } from '../redux/hooks';

const Delete: React.FC = (): JSX.Element => {
	// HOOKS
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const location = useLocation();
	const { t } = useTranslation();
	// REDUX STATE
	const {
		requestingRemoveLayer,
		requestingRemoveSource,
		requestingUpdateTileserver
	} = useReduxState<IMapFeaturesState>('mapFeatures');
	// REDUX ACTIONS
	const requestRemoveSourceDispatch = bindActionCreators(requestRemoveSource, dispatch);
	const requestRemoveLayerDispatch = bindActionCreators(requestRemoveLayer, dispatch);
	// VARIABLES
	const isLayer = location.pathname.indexOf('/layers') > -1;
	const isLoading = requestingRemoveLayer || requestingRemoveSource || requestingUpdateTileserver;
	const asset = location.state as IMapFeatureRow;
	const previousRequestingUpdateTileServer = usePrevious(requestingUpdateTileserver);
	const { name, id } = asset;

	const handleConfirm = () => {
		if (!isLayer) {
			requestRemoveSourceDispatch(id);
		}
		else {
			requestRemoveLayerDispatch(id);
		}
	};

	useEffect(() => {
		if (!requestingUpdateTileserver && previousRequestingUpdateTileServer) {
			navigate('/assets', { state: { tab: isLayer ? 'layers' : 'sources' } });
		}

	}, [ requestingUpdateTileserver ]);

	return (
		<div className="container">
			<div className="row">
				<div className="col">
					{ isLoading && <Loader message={ t('PROCESSING') } /> }

					{
						!isLoading && <>
							<h1>Delete { isLayer ? 'Orphaned Layer' : 'Asset' }</h1>

							<Form>
							Are you sure you want to delete the { name }?

								<div className='vio-form-footer'>
									<Button outline onClick={ () => navigate(-1) }>
										{ t('CANCEL') } <FontAwesomeIcon icon={ faTimes } aria-hidden transform='right-1' />
									</Button>

									<Button variant='success' onClick={ handleConfirm }>
										{ t('YES') } <FontAwesomeIcon icon={ faCheck } aria-hidden transform='right-1' />
									</Button>
								</div>
							</Form>
						</>
					}
				</div>
			</div>
		</div>
	);
};

export default Delete;
